<template>
	<div class="field">
		<label class="label">{{ label }}</label>
		<div class="control">
			<v-jsoneditor
				v-model="myValue"
				:plus="false"
				height="600px"
				:options="options"
				@error="onError"
			></v-jsoneditor>
		</div>
		<pre v-if="jsonError" class="help is-danger">{{ jsonError }}</pre>
	</div>
</template>

<script>
import fieldMixin from "@lab/utils/fieldMixin";
import VJsoneditor from "v-jsoneditor/src/index";

export default {
	components: { VJsoneditor },
	mixins: [fieldMixin],
	props: {
		placeholder: {
			type: String,
			default: () => null
		},
		label: {
			type: String,
			required: true
		},
		options: {
			type: Object,
			default: () => {
				return {
					mode: "code"
				};
			}
		}
	},
	data() {
		return {
			jsonError: null
		};
	},
	computed: {
		myValue: {
			get() {
				return JSON.parse(this.value);
			},
			set(json) {
				this.jsonError = null;
				this.blur(JSON.stringify(json));
			}
		}
	},
	methods: {
		onError(error) {
			this.jsonError = error.toString();
		}
	}
};
</script>

<style lang="scss" scoped></style>
